import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Icon } from '@centivo/react-components'
import styled from 'styled-components'
import { Logo, NavSlice, NavlistSlice } from './components'
import { useNavbarFunctions } from './useNavbarFunctions'

interface NavbarSliceProps {
  onRequestContact(): void
}

const BackButton = styled.a`
  display: block;
  position: absolute;
  left: 1.25rem;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background-color: #5e58f6;

  &:hover,
  &:active,
  &:focus {
    background-color: ${({ theme }) => theme.palette.brand.darkPurple};
  }
`

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 1.375rem;
  right: 1.25rem;
`

const StyledMenuIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.brand.orange};
`

const Overlay = styled.div`
  position: fixed;

  top: 0;
  left: 0;

  height: 100vh;
  width: 100vw;

  background-color: rgba(0, 0, 0, 0.3);

  z-index: 0;
`

export const NavbarSlice: React.FC<NavbarSliceProps> = ({
  onRequestContact,
}) => {
  const {
    onClickLink,
    clickToggle,

    isSliderOpen,
    style,
    isMobileView,
    contactLink,
    phoneNumber,
    phoneText,
    atLeastOneNavItem,

    shouldShowUnderConstruction,
    shouldShowContactForm,
    shouldShowNumberOnMenu,
    shouldShowAlreadyMember,
    shouldShowEligibilityLink,
    eligibilityLinkUrl,
    template,
  } = useNavbarFunctions()

  const shouldShowNav = !(isMobileView && template === 'template-eligibility')

  return (
    <NavSlice className="main-navbar">
      {isSliderOpen && <Overlay />}
      <Link to="/">
        <Logo />
      </Link>
      {template === 'template-eligibility' &&
        isMobileView &&
        shouldShowEligibilityLink && (
          <BackButton onClick={onClickLink} href={eligibilityLinkUrl}>
            <Icon icon="slice-curly-arrow-left" size="32px" />
          </BackButton>
        )}
      {isMobileView && atLeastOneNavItem && !shouldShowUnderConstruction && (
        <StyledMenuIcon
          size="1.5rem"
          icon="slice-menu"
          onClick={clickToggle}
          aria-label="Open menu"
        />
      )}
      {shouldShowNav && (
        <NavlistSlice style={style} className="main-navlist" role="none">
          {isMobileView && (
            <li>
              <Link to="/" onClick={onClickLink}>
                <p>
                  <span>Home</span>
                </p>
                <hr />
              </Link>
            </li>
          )}

          {shouldShowContactForm && !shouldShowUnderConstruction && (
            <li>
              {isMobileView ? (
                <Link to={contactLink} onClick={onClickLink}>
                  <p>
                    <span>Contact us</span>
                  </p>
                  <hr />
                </Link>
              ) : (
                <Button buttonType="link" onClick={onRequestContact}>
                  Contact us
                </Button>
              )}
            </li>
          )}
          {shouldShowNumberOnMenu && !shouldShowUnderConstruction && (
            <li>
              <a href={`tel:${phoneNumber}`}>
                <p>
                  <span>{phoneText}</span>
                </p>
                {isMobileView && <hr />}
              </a>
            </li>
          )}
          {shouldShowAlreadyMember && !shouldShowUnderConstruction && (
            <li>
              <a href="https://my.centivo.com/" onClick={onClickLink}>
                <p>
                  <span>Already a member?</span>
                </p>
                {isMobileView && <hr />}
              </a>
            </li>
          )}
          {template === 'template-eligibility' && shouldShowEligibilityLink && (
            <li>
              <a href={eligibilityLinkUrl} onClick={onClickLink}>
                Take me back to Centivo
              </a>
            </li>
          )}
          {isMobileView && (
            <StyledIcon icon="slice-x" size="1.5rem" onClick={clickToggle} />
          )}
        </NavlistSlice>
      )}
    </NavSlice>
  )
}
